module.exports = __webpack_public_path__ + "img/lake.be5030ca.webp";